import { action } from "satcheljs";

import type { OwaNovaActionUnion } from "../types";

export const onOpenProfileEditor = action("onOpenProfileEditor", event => ({
    event,
    owaType: "openProfileEditor",
})) as OwaNovaActionUnion<"openProfileEditor">;
